import { FilterSection } from "@flights/search-ui";
import React from "react";
import { useAirlinesFilterController } from "./useAirlinesFilter.controller";
import AirlinesFilterItem from "./AirlinesFilterItem";
import { AirlinesFilterOptions } from "./AirlinesFilterOptions";
import flights_web_budget_layover_airports_filters from "../../../../../utils/experiments/funnel/flights_web_budget_layover_airports_filters";

export const AirlinesFilterDesktop = () => {
  const {
    isFilterAvailable,
    title,
    showReset,
    resetLabel,
    onClickReset,
    options,
    value,
    onChange,
    onSelectSingleOption,
    optionsLimit,
    areOptionsTrucanted,
    optionsTogglerLabel,
    optionsTogglerIcon,
    onTogglerClick,
    singleOptionLabel
  } = useAirlinesFilterController();

  if (!isFilterAvailable) return null;

  const addNewFilters = !!flights_web_budget_layover_airports_filters.trackWithDefaultStage();

  return (
    <FilterSection
      attributes={{ "data-testid": "airlines_filter" }}
      title={{
        text: title,
        tagName: addNewFilters ? "h3" : "h2",
        attributes: { id: "airlines_filter" },
        variant: addNewFilters ? "strong_2" : "emphasized_1"
      }}
      reset={
        showReset && !addNewFilters
          ? { text: resetLabel, onClick: onClickReset, attributes: { "data-testid": "search_filter_airline_reset" } }
          : undefined
      }
    >
      <AirlinesFilterOptions
        gap={2}
        togglerLabel={optionsTogglerLabel}
        togglerIcon={optionsTogglerIcon}
        onTogglerClick={onTogglerClick}
        options={options}
        optionsLimit={optionsLimit}
        areOptionsTrucanted={areOptionsTrucanted}
        renderOption={({ option, isHidden, index }) => (
          <AirlinesFilterItem
            key={`${index}-${option.value}`}
            value={option.value}
            label={option.label}
            count={option.count}
            checked={value.includes(option.value)}
            onChange={onChange}
            isHidden={isHidden}
            canSelectSingleOption={true}
            onSelectSingleOption={onSelectSingleOption}
            singleOptionLabel={singleOptionLabel}
          />
        )}
      />
    </FilterSection>
  );
};
